<template>
  <div
    class="grid-x grid-padding-x grid-padding-y pega-form"
    :class="formClassName"
    data-test="form-class"
  >
    <div
      class="medium-3 cell pega-form-label"
      :class="className"
      data-test="form-label"
    >
      <slot name="label" />
      <span v-if="label">{{ label }}</span>
      <span
        v-if="requiredLabel"
        class="label alert pega-block-fit-content"
        data-test="alert-label"
      >{{ requiredLabel }}</span>
    </div>
    <div class="auto cell">
      <slot name="header" />
      <slot name="body" />
      <slot name="error" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    isRequired: {
      default: false,
      type: Boolean
    },
    required: {
      type: String,
      default: ''
    },
    formClassName: {
      type: String,
      default: ''
    }
  },
  computed: {
    requiredLabel () {
      return this.required ? this.required
        : this.isRequired ? '必須' : ''
    }
  }
}
</script>
